// Default Imports
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// Redux Imports
import { Store } from './state';

// Components Imports
import NavigationRoutes from './routes';

// Styles Imports
// import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/main.css';
import './assets/fonts/font.css';
import './styles/pages/custom.scss';
// import 'antd/dist/antd.css';
// import './styles/components/country-code-dropdown.scss';
import { getUserToken } from './common/resubale-functions';
import http from './api/api';
import { ContextProvider } from './components/context/context';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import mixpanel from "mixpanel-browser";


mixpanel.init(process.env.MIXPANEL_TOKEN, { debug: true });

const container = document.getElementById('root');
const root = createRoot(container);
const token = getUserToken();

token ? (http.defaults.headers.common['Authorization'] = `JWT ${token}`) : null;

root.render(
  <ContextProvider>
    <Provider store={Store}>
      <NavigationRoutes />
      <ToastContainer
        position='bottom-center'
        autoClose={2500}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        closeButton={false}
        draggable
        theme='dark'
      />
    </Provider>
  </ContextProvider>
);
